module.exports = __webpack_public_path__ + "assets/images/EUR2.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR2.png
// module id = 1365
// module chunks = 1